import { useSyncExternalStore } from "react";
import type { StepExecutionItem } from "../../shared/executions/executionListTypes";

let executions: readonly StepExecutionItem[] = [];
const listeners = new Set<() => void>();

function publish(next: readonly StepExecutionItem[]) {
  executions = next;
  for (const listener of listeners) listener();
}

export function addOptimisticStepExecution(execution: StepExecutionItem) {
  publish([execution, ...executions.filter((row) => row.id !== execution.id)]);
  return () => publish(executions.filter((row) => row.id !== execution.id));
}

export function removeOptimisticStepExecutions(ids: ReadonlySet<string>) {
  const next = executions.filter((row) => !ids.has(row.id));
  if (next.length !== executions.length) publish(next);
}

export function mergeStepExecutions(
  retained: readonly StepExecutionItem[],
  optimistic: readonly StepExecutionItem[]
): StepExecutionItem[] {
  const rows = new Map(optimistic.map((row) => [row.id, row]));
  for (const row of retained) rows.set(row.id, row);
  return [...rows.values()].sort(
    (a, b) => b.createdAt - a.createdAt || b.id.localeCompare(a.id)
  );
}

export function useOptimisticStepExecutions(
  workflowId: string,
  branchId: string,
  stepDir: string
) {
  const snapshot = useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => executions,
    () => executions
  );
  return snapshot.filter(
    (row) =>
      row.workflowId === workflowId &&
      row.branchId === branchId &&
      row.stepDir === stepDir
  );
}
